<template>
  <form :class="classes" :autocomplete="autocomplete">
    <slot />
  </form>
</template>
<script>
const prefixCls = 'tt-form'

export default {
  name: 'Form',
  props: {
    model: {
      type: Object
    },
    rules: {
      type: Object
    },
    labelWidth: {
      type: Number
    },
    labelPosition: {
      type: 'left' | 'right' | 'top',
      default: 'top'
    },
    inline: {
      type: Boolean,
      default: false
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    autocomplete: {
      type: 'on' | 'off',
      default: 'off'
    },
    hideRequiredMark: {
      type: Boolean,
      default: false
    },
    labelColon: {
      type: [Boolean, String],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  provide() {
    return { $ttForm: this }
  },
  data() {
    return {
      fields: []
    }
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        `${prefixCls}-label-${this.labelPosition}`,
        {
          [`${prefixCls}-inline`]: this.inline,
          [`${prefixCls}-hide-required-mark`]: this.hideRequiredMark
        }
      ]
    },
    colon() {
      let colon = ''
      if (this.labelColon) {
        colon = typeof this.labelColon === 'boolean' ? ':' : this.labelColon
      }
      return colon
    }
  },
  methods: {
    resetFields() {
      this.fields.forEach(field => {
        field.resetField()
      })
    },
    clearErrors() {
      this.fields.forEach(field => {
        field.clearError()
      })
    },
    validate(callback) {
      return new Promise(resolve => {
        let valid = true
        let count = 0
        this.fields.forEach(field => {
          field.validate('', errors => {
            if (errors) {
              valid = false
            }
            if (++count === this.fields.length) {
              // all finish
              resolve(valid)
              if (typeof callback === 'function') {
                callback(valid)
              }
            }
          })
        })
      })
    },
    validateField(prop, cb) {
      const field = this.fields.filter(field => field.prop === prop)[0]
      if (!field) {
        throw new Error(
          '[warn]: Must call validateField with valid prop string'
        )
      }

      field.validate('', cb)
    }
  },
  watch: {
    rules() {
      this.validate()
    }
  },
  created() {
    this.$on('on-form-item-add', field => {
      if (field) this.fields.push(field)
      return false
    })
    this.$on('on-form-item-remove', field => {
      if (field.prop) this.fields.splice(this.fields.indexOf(field), 1)
      return false
    })
  }
}
</script>
<style lang="less">
@import '~uikit';
@form-prefix-cls: ~'tt-form';
@form-item-prefix-cls: ~'tt-form-item';
.@{form-prefix-cls} {
  .@{form-item-prefix-cls}-label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 12px;
    color: @black;
    line-height: 17px;
    padding: 10px 12px 10px 0;
    box-sizing: border-box;
  }
  &-label-left .@{form-item-prefix-cls}-label {
    text-align: left;
  }
  &-label-top .@{form-item-prefix-cls}-label {
    float: none;
    display: inline-block;
    padding: 0 0 5px 0;
  }
  &-inline {
    .@{form-item-prefix-cls} {
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
  }
}

.@{form-item-prefix-cls} {
  margin-bottom: 15px;
  vertical-align: top;
  zoom: 1;
  &:before,
  &:after {
    content: '';
    display: table;
  }
  &:after {
    clear: both;
    visibility: hidden;
    font-size: 0;
    height: 0;
  }
  &-content {
    position: relative;
    line-height: 32px;
    font-size: 12px;
  }
  & & {
    margin-bottom: 0;
  }
  & & &-content {
    margin-left: 0 !important;
  }

  &-error-tip {
    top: 100%;
    left: 0;
    line-height: 1.4;
    color: @red;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    font-weight: bold;
    .icon {
      display: inline-block;
      margin-top: 2px;
      flex-shrink: 0;
      width: 12px;
      height: 12px;
      font-size: 12px;
      color: @red;
      margin-right: 5px;
    }
  }

  &-required {
    .@{form-item-prefix-cls}-label:before {
      content: '*';
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-size: 12px;
      color: red;
    }
  }
  &-error {
    .tt-input {
      border-color: @red;
    }
  }
}

.@{form-prefix-cls}-hide-required-mark .@{form-item-prefix-cls}-required {
  .@{form-item-prefix-cls}-label:before {
    display: none;
  }
}
</style>
